import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Button } from 'reactstrap';
import Select from 'react-select';

import InvoiceAdditionsList from './InvoiceAdditionsList';
import {
  enumHelper,
  dataGenerator,
  permissionHelper,
  formatter,
} from '../../../../utils';
import enums from '../../../../enums';
import Spin from '../../../../components/loading';
import styles from './styles.scss';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';
import ConfirmationModal from '../../../../components/confirmarion-modal/confirmation-modal';
import  { useReactToPrint } from 'react-to-print';
import InvoiceToPrint from '../../invoiceToPrint';
import socketIoClient from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import actionTypes from '../../../../redux/reservations/actionTypes';
import DataToPrint from '../../invoiceToPrint/DataToPrint';
import ButtonLoader from '../../../../components/Button Loader/Loader';
import OrderRegister from './OrderRegister';

const { EDIT_INVOICE, VIEW_USER_MOBILE_NUMBER } = enums.PERMISSIONS.values;

function InvoiceDetails(props) {
  const dispatch = useDispatch();
  const {
    reservationTemporaryReceipt,
    reservationFactorPrint,
    reservationPrintData,
    reservationInvoiceDetails,
    reservationTemporaryReceiptLoading,
    reservationFactorPrintLoading,
    finalSaveStatus,
    tabletPrintReq
  } = useSelector(state => ({
    reservationTemporaryReceipt:
      state.reservationsReducer.reservationTemporaryReceipt,
    reservationFactorPrint: state.reservationsReducer.reservationFactorPrint,
    reservationPrintData: state.reservationsReducer.reservationPrintData,
    reservationInvoiceDetails:
      state.reservationsReducer.reservationInvoiceDetails,
    reservationTemporaryReceiptLoading:
      state.reservationsReducer.reservationTemporaryReceiptLoading,
    reservationFactorPrintLoading:
      state.reservationsReducer.reservationFactorPrintLoading,
    finalSaveStatus: state.reservationsReducer.reservationInvoiceStatus,
    tabletPrintReq: state.reservationsReducer.tabletPrintReq,
  }));
  const [printerType, setPrinterType] = useState('');
  const [printFactor, setPrintFactor] = useState(false);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [onlinePaidAmount, setOnlinePaidAmount] = useState(0);
  const [newItemQuantity, setNewItemQuantity] = useState(1);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [newInvoiceItems, setNewInvoiceItems] = useState([]);
  const [toBePaidToCafePrice, setToBePaidToCafePrice] = useState(0);
  const [discountCodeAmount, setDiscountCodeAmount] = useState(0);
  const [hourlyDiscountsAmount, setHourlyDiscountsAmount] = useState(0);
  const [hourlyDiscountPercent, setHourlyDiscountPercent] = useState(0);
  const [totalEntranceAmount, setTotalEntranceAmount] = useState(0);
  const [invoiceAdditionsAmount, setInvoiceAdditionsAmount] = useState(0);
  const [rseePercent, setRseePercent] = useState(0);
  const [rseeStockAmount, setRseeStockAmount] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(
    false,
  );
  const [confirmationModalTitle, setConfirmationModalTitle] = useState('');
  const [confirmationModalContent, setConfirmationModalContent] = useState('');
  const [tempSaveData, setTempSaveData] = useState(null);
  const [isTempSaveBtnClicked, setIsTempSaveBtnClicked] = useState(false);
  const [isFinalSave, setIsFinalSave] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectValue, setSelectValue] = useState('');
  const [invoiceDiscountCodeAmount, setInvoiceDiscountCodeAmount] = useState(0);
  const [isNeedRefresh, setIsNeedRefresh] = useState(false);
  const [receiptLoading, setReceiptLoading] = useState(false);
  const [factorLoading, setFactorLoading] = useState(false);
  const [disabledInvoice, setDisabledInvoice] = useState(true);
  const [disabledFactors, setDisabledFactors] = useState(true);
  const [disabledFinalSave, setDisabledFinalSave] = useState(true);
  const [loader, setLoader] = useState(false);

  const invoiceToPrintRef = useRef();
  const windowsPrintersRef = useRef();

  const loading =
    props.fetchDataLoading ||
    props.getMenuItemsLoading ||
    props.temporarySaveLoading ||
    props.finalSaveLoading ||
    reservationTemporaryReceiptLoading ||
    reservationFactorPrintLoading ||
    printerLoading;

  const editable =
    permissionHelper.hasUserPermission(EDIT_INVOICE) &&
    props.reserveStatus === enums.CAFE_RESERVATION.values.STARTED &&
    props.invoiceStatus === enums.INVOICE_STATUS.values.TEMPORARY_SAVE &&
    !loading;

  const menuItemsSelectOption = useMemo(() => {
    let options = props.menuItemsList;
    if (selectValue !== '') {
      options = options?.filter(
        option => selectValue === option.title.slice(0, selectValue.length),
      );
    }
    options = options
      ?.filter(x => invoiceItems.findIndex(y => y.menuItemId === x.id) < 0)
      .sort((a, b) => {
        if (a.title > b.title) {
          return 1;
        } else if (a.title < b.title) {
          return -1;
        }
        return 0;
      })
      .map(x => ({
        label: x.title,
        value: x.id,
      }));
    return options;
  }, [props.menuItemsList, selectValue]);

  const close = () => {
    props.close(isNeedRefresh);
  };

  const formatTablesNum = tablesNum => {
    if (!tablesNum || !tablesNum.length) {
      return null;
    }

    return tablesNum.map(x => x.num).join('، ');
  };

  const showReserveTimePeriod = () => {
    if (!props.reserveStartAt || !props.reserveEndAt) {
      return '';
    }

    return `از ${props.reserveStartAt.slice(-5)} تا ${props.reserveEndAt.slice(
      -5,
    )}`;
  };

  const renderPreOrderedItems = () => {
    if (!props.menuItems || !props.menuItems.length) {
      return null;
    }

    const preOrderedItems = props.menuItems.map(x => `${x.title} (${x.count})`);
    const joinedItemsString = preOrderedItems.join('، ');

    return joinedItemsString;
  };

  const addNewItem = (item, category) => {
    const index = invoiceItems.findIndex(x => x.menuItemId === item.menuItemId);
    let quantity = 1;
    const clonedInvoiceItems = [...invoiceItems]
    console.log(clonedInvoiceItems)
    if (index === -1) {
      clonedInvoiceItems.push({
        id: props.reserveId,
        menuItemId: item.menuItemId,
        title: item.menuItemTitle,
        price: item.menuItemPrice,
        printerTarget: category.printerTarget,
        quantity: quantity,
        clientKey: dataGenerator.generateKey('invoiceItem'),
      })
    } else {
      quantity = clonedInvoiceItems[index].quantity + 1;
      clonedInvoiceItems[index] = {
        ...clonedInvoiceItems[index],
        quantity: quantity,
      }
    }
    setInvoiceItems(clonedInvoiceItems);
    setNewInvoiceItems(clonedInvoiceItems);
    setDisabledInvoice(true);
    setDisabledFinalSave(true);
    setNewItemQuantity(quantity);
    calculate(clonedInvoiceItems);
  }

  const calculate = clonedInvoiceItems => {
    const subTotal = clonedInvoiceItems.reduce((acc, current) => {
      return acc + current.price * current.quantity;
    }, 0);
    setSubTotalPrice(subTotal);
    setTotalPrice(subTotal - onlinePaidAmount);
  };

  const changeInvoiceItemQuantity = (clientKey, val) => {
    if (val && val >= 1 && val <= 512) {
      const clonedInvoiceItems = [...invoiceItems];
      const invoiceItem = clonedInvoiceItems.find(
        x => x.clientKey === clientKey,
      );
      invoiceItem.quantity = val;
      setInvoiceItems(clonedInvoiceItems);
      setNewInvoiceItems(clonedInvoiceItems);
      setDisabledInvoice(true);
      setDisabledFinalSave(true);
      calculate(clonedInvoiceItems);
    }
  };

  const renderInvoiceItemQuantity = invoiceItem => {
    if (
      permissionHelper.hasUserPermission(EDIT_INVOICE) &&
      props.reserveStatus === enums.CAFE_RESERVATION.values.STARTED
    ) {
      return (
        <Row>
          <button className="btn btn-success btn-sm mx-2" onClick={() => changeInvoiceItemQuantity(invoiceItem.clientKey, invoiceItem.quantity + 1)}>
            <i class="fa fa-plus  m-0" aria-hidden="true"></i>
          </button>
          <b className="mt-1 mx-2" style={{ fontSize: "15px" }}>{invoiceItem.quantity}</b>

          <button className="btn btn-danger btn-sm mx-2" onClick={() => changeInvoiceItemQuantity(invoiceItem.clientKey, invoiceItem.quantity - 1)}>
            <i class="fa fa-minus m-0" aria-hidden="true"></i>
          </button>
        </Row>
      );
    } else {
      return invoiceItem.quantity;
    }
  };

  const handleTempSaveClick = () => {
    setConfirmationModalTitle('اخطار');
    setConfirmationModalContent('آیا از ثبت موقت موارد انتخابی اطمینان دارید؟');
    setIsTempSaveBtnClicked(true);
    setIsFinalSave(false);
    setConfirmationModalVisible(true);
  };

  const tempSave = async e => {
    setLoader(true);

    const finalIvoices = invoiceItems.map(invoice => ({
      id: invoice.id,
      title: invoice.title,
      menuItemId: invoice.menuItemId,
      quantity: invoice.quantity,
      printerTarget: invoice.printerTarget,
    }));
    try {
      e.preventDefault();
     const response =  await props.temproraySave(props.invoiceId, finalIvoices);
      await props.getInvoiceDataByReserveId(props.reserveId);
      setTempSaveData(response)
      if (response.isLessThanBaseCost){
        setIsModalVisible(true)
      }else {
        await AlertAndConfirmation({
          type: 'success',
          title: locales('messages.reserve.request.was.approved'),
          text: 'عملیات با موفقیت انجام شد',
        });
      }


    } catch (error) {
      setLoader(false);
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
      setNewInvoiceItems([]);
      setDisabledInvoice(false);
      setDisabledFinalSave(false);
      setLoader(false);
    }
  };

  const handleFinalSaveClick = () => {
    setConfirmationModalTitle('اخطار');
    setConfirmationModalContent(
      'آیا از ثبت نهایی موارد انتخابی اطمینان دارید؟',
    );
    setIsTempSaveBtnClicked(false);
    setIsFinalSave(true);
    setConfirmationModalVisible(true);
  };

  const finalSave = async e => {
    setLoader(true);

    const finalIvoices = invoiceItems.map(invoice => ({
      id: invoice.id,
      title: invoice.title,
      menuItemId: invoice.menuItemId,
      quantity: invoice.quantity,
      printerTarget: invoice.printerTarget,
    }));
    try {
      e.preventDefault();
      await props.finalSave(props.invoiceId, finalIvoices);
      await props.getInvoiceDataByReserveId(props.reserveId);
      setIsNeedRefresh(true);
      AlertAndConfirmation({
        type: 'success',
        title: locales('messages.reserve.request.was.approved'),
        text: 'عملیات با موفقیت انجام شد',
      });
    } catch (error) {
      setLoader(false);
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
      setDisabledFactors(false);
      setDisabledInvoice(false);
      setDisabledFinalSave(true);
      setLoader(false);
    }
  };


  const onClickPrintFactor = async () => {
    try {
      await props.getReservationFactorPrint(props.reserveId);
      setPrintFactor(true);
    } catch (error) {
      setPrintFactor(false);
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
    }
  };

  const handlePrintInvoiceAgain = useReactToPrint({
    content: () => invoiceToPrintRef.current,
  });

  const handlePrintInvoiceResponse = useReactToPrint({
    content: () => windowsPrintersRef.current,
    bodyClass: 'printerBody',
  });

  const handleReceiptIssued = async () => {
    try {
      setPrinterLoading(true);
      await props.getReservationTemporaryPrint(props.reserveId, "PRINT");
      setReceiptLoading(true);
      setPrinterLoading(false);
    } catch (error) {
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
    }
  };

  const handleReceiptResponseWithSocket = () => {
    setPrinterLoading(true);

    const data = { payload: reservationTemporaryReceipt };
    console.log(data);
    const socketInvoice = socketIoClient(
      'http://localhost:8181/invoice?token=abc123',
      {
        transports: ['polling', 'websocket'],
      },
    );

    socketInvoice.on('connect', _ => {
      console.log('socket io connected');
      // console.log(socketInvoice);
    });
    socketInvoice.on('disconnect', _ => {
      setPrinterLoading(false);
      console.log('socket io was disconnected');
    });
    socketInvoice.on('reconnect_attempt', attempts => {
      setPrinterLoading(false);
      console.log('socket Try to reconnect at ' + attempts + ' attempt(s).');
    });

    socketInvoice.emit('invoice', data);

    socketInvoice.on('invoice', data => {
      setPrinterLoading(false);
      console.log('Received message', data);
      AlertAndConfirmation({
        type: 'error',
        title: data,
      });
    });

    setReceiptLoading(false);
  };

  const handleSendInvoiceResponseWithSocket = () => {
    setPrinterLoading(true);
    const data = { payload: reservationPrintData };
    /* console.log(data);
    socketInvoice.emit('invoice', data);

    socketInvoice.on('invoice', data => {
      setPrinterLoading(false);
      console.log('Received message', data);
      AlertAndConfirmation({
        type: 'error',
        title: data,
      });
    }); */
    const socketInvoice = socketIoClient(
      'http://localhost:8181/invoice?token=abc123',
      {
        transports: ['polling', 'websocket'],
      },
    );

    socketInvoice.on('connect', _ => {
      console.log('socket io connected');
      console.log(socketInvoice);
    });
    socketInvoice.on('disconnect', _ => {
      setPrinterLoading(false);
      console.log('socket io was disconnected');
    });
    socketInvoice.on('reconnect_attempt', attempts => {
      setPrinterLoading(false);
      console.log('socket Try to reconnect at ' + attempts + ' attempt(s).');
    });

    socketInvoice.emit('invoice', data);

    socketInvoice.on('invoice', data => {
      setPrinterLoading(false);
      socketInvoice.close();
      console.log('Received message', data);
      AlertAndConfirmation({
        type: 'error',
        title: data,
      });
    });
  };

  const handleSendIFactorResponseWithSocket = () => {
    setPrinterLoading(true);
    const data = { payload: reservationFactorPrint };

    const socketFactor = socketIoClient(
      'http://localhost:8181/factor?token=abc123',
      {
        transports: ['polling', 'websocket'],
      },
    );

    socketFactor.on('connect', function () {
      console.log('socket io connected');
    });
    socketFactor.on('disconnect', function () {
      setPrinterLoading(false);
      console.log('socket io was disconnected');
    });
    socketFactor.on('reconnect_attempt', attempts => {
      setPrinterLoading(false);
      console.log('socket Try to reconnect at ' + attempts + ' attempt(s).');
    });
    socketFactor.emit('factor', data);

    socketFactor.on('factor', function (data) {
      setPrinterLoading(false);
      socketFactor.close();
      console.log('Received message', data);
      AlertAndConfirmation({
        type: 'error',
        title: data,
      });
    });
    setFactorLoading(false);
  };

  const handleTabletDataSocket = () => {
    console.log("tabletPrintReq" , tabletPrintReq)
    if(tabletPrintReq.type === "FACTOR") {
      setPrinterLoading(true);
      const data = { payload: tabletPrintReq.payload };
      console.log("socketFactor data" , data)
      const socketFactor = socketIoClient(
        'http://localhost:8181/factor?token=abc123',
        {
          transports: ['polling', 'websocket'],
        },
      );
  
      socketFactor.on('connect', function () {
        console.log('socketFactor io connected');
      });
      socketFactor.on('disconnect', function () {
        setPrinterLoading(false);
        console.log('socketFactor io was disconnected');
      });
      socketFactor.on('reconnect_attempt', attempts => {
        setPrinterLoading(false);
        console.log('socketFactor Try to reconnect at ' + attempts + ' attempt(s).');
      });
      socketFactor.emit('factor', data);
  
      socketFactor.on('factor', function (data) {
        setPrinterLoading(false);
        socketFactor.close();
        console.log('socketFactor Received message', data);
        AlertAndConfirmation({
          type: 'error',
          title: data,
        });
      });
      setFactorLoading(false);
    }
     else if (tabletPrintReq.type === "INVOICE") {
      setPrinterLoading(true);
      const data = { payload: tabletPrintReq.payload };
      console.log("socketInvoice data" , data)
      const socketInvoice = socketIoClient(
        'http://localhost:8181/invoice?token=abc123',
        {
          transports: ['polling', 'websocket'],
        },
      );
  
      socketInvoice.on('connect', _ => {
        console.log('socketInvoice io connected');
        // console.log(socketInvoice);
      });
      socketInvoice.on('disconnect', _ => {
        setPrinterLoading(false);
        console.log('socketInvoice io was disconnected');
      });
      socketInvoice.on('reconnect_attempt', attempts => {
        setPrinterLoading(false);
        console.log('socketInvoice Try to reconnect at ' + attempts + ' attempt(s).');
      });
  
      socketInvoice.emit('invoice', data);
  
      socketInvoice.on('invoice', data => {
        setPrinterLoading(false);
        console.log('socketInvoice Received message', data);
        AlertAndConfirmation({
          type: 'error',
          title: data,
        });
      });
  
      setReceiptLoading(false);
     }
   
  };

  const handleFactorIssued = async () => {
    try {
      setPrinterLoading(true);
      await props.getReservationFactorPrint(props.reserveId);
      setFactorLoading(true);
      setPrinterLoading(false);
    } catch (error) {
      setPrinterLoading(false);
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
    }
  };

  const handlePrinterTarget = async (item, type) => {
    setPrinterType(type);
    try {
      setPrinterLoading(true);
      await props.getReservationTemporaryPrintByPrinterTarget(
        props.reserveId,
        item.printerTarget,
      );
      setPrinterLoading(false);
    } catch (error) {
      setPrinterLoading(false);
      console.log(error);
      AlertAndConfirmation({
        type: 'error',
        text: error,
      });
    } finally {
      setConfirmationModalVisible(false);
    }
  };

  const formatCurrencyValue = (currencyValue, withCurrency = false) => {
    let result = formatter.numberWithCommas(currencyValue || 0);
    if (withCurrency === true) {
      result +=
        ' ' +
        enumHelper.convertEnumValueToTitle(enums.CURRENCY.list, props.currency);
    }

    return result;
  };

  const formatBalanceAmount = balanceAmount => {
    if (balanceAmount === 0) {
      return 'تسویه';
    } else if (balanceAmount > 0) {
      return `${formatter.numberWithCommas(balanceAmount)} تومان`;
    } else if (balanceAmount < 0) {
      return `${formatter.numberWithCommas(Math.abs(balanceAmount))}-   تومان`;
    }
  };

  const removeItemFromInvoice = itemClientKey => {
    let clonedInvoiceItems = [...invoiceItems];
    clonedInvoiceItems = clonedInvoiceItems.filter(
      x => x.clientKey !== itemClientKey,
    );
    setInvoiceItems(clonedInvoiceItems);
    setNewInvoiceItems(clonedInvoiceItems);
    setDisabledInvoice(true);
    setDisabledFinalSave(true);
    calculate(clonedInvoiceItems);
  };

  useEffect(() => {
    console.log(window.navigator.platform)
    // handleConnectSocket();
    dispatch({
      type: actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_SUCCESS,
      payload: [],
    });
  }, []);

  useEffect(() => {
    if(tabletPrintReq) {
      console.log(tabletPrintReq)
      handleTabletDataSocket()
    }
  }, [tabletPrintReq]);

  useEffect(() => {
    (async () => {
      if (
        reservationInvoiceDetails.invoiceStatus === 'TEMPORARY_SAVE' &&
        reservationInvoiceDetails.invoiceItems?.length > 0
      ) {
        await props.getReservationTemporaryPrint(props.reserveId, "NOTPRINT");
      }
    })();
  }, [
    reservationInvoiceDetails.invoiceStatus,
    reservationInvoiceDetails.invoiceItems,
  ]);

  useEffect(() => {
    if (factorLoading) {
      handleSendIFactorResponseWithSocket();
    }

    console.log('printFactor', printFactor);
    console.log('reservationFactorPrint', reservationFactorPrint);
    if (printFactor) {
      handlePrintInvoiceAgain();
      setPrintFactor(false);
    }
  }, [reservationFactorPrint, factorLoading, printFactor]);

  // صدور فیش
  useEffect(() => {
    if (receiptLoading && reservationTemporaryReceipt.length > 0) {
      handleReceiptResponseWithSocket();
    }
  }, [reservationTemporaryReceipt, receiptLoading]);

  // پرینترهای تحت شبکه و ویندوز
  useEffect(() => {
    if (reservationPrintData.length > 0 && printerType === 'network') {
      handleSendInvoiceResponseWithSocket();
    }
    if (reservationPrintData.length > 0 && printerType === 'windows') {
      handlePrintInvoiceResponse();
    }
  }, [reservationPrintData]);

  useEffect(function () {
    props.getInvoiceDataByReserveId(props.reserveId);
  }, []);

  useEffect(
    function () {
      setSubTotalPrice(props.subTotalPrice);
      setTotalPrice(props.totalPrice);
      setOnlinePaidAmount(props.reserveBaseCost);
      setToBePaidToCafePrice(props.toBePaidToCafePrice);
      setDiscountCodeAmount(props.discountCodeAmount);
      setHourlyDiscountsAmount(props.hourlyDiscountAmount);
      setHourlyDiscountPercent(props.hourlyDiscountPercent);
      setTotalEntranceAmount(props.totalEntranceAmount);
      setInvoiceAdditionsAmount(props.invoiceAdditionsAmount);
      setRseePercent(props.rseePercent);
      setRseeStockAmount(props.rseeStockAmount);
      setBalanceAmount(props.balanceAmount);
      setInvoiceDiscountCodeAmount(props.invoiceDiscountCodeAmount);

      if (props.invoiceItems) {
        const mappedInvoiceItems = props.invoiceItems.map(x => ({
          ...x,
          clientKey: dataGenerator.generateKey('invoiceItem'),
        }));
        setInvoiceItems(mappedInvoiceItems);
        if (mappedInvoiceItems.length !== 0) {
          setDisabledInvoice(false);
          setDisabledFinalSave(false);
        } else {
          setDisabledInvoice(true);
          setDisabledFinalSave(true);
        }
      }

      if (
        permissionHelper.hasUserPermission(EDIT_INVOICE) &&
        props.reserveStatus === enums.CAFE_RESERVATION.values.STARTED
      ) {
        props.getMyCafeMenuItems();
      }

      if (finalSaveStatus === 'FINISHED') {
        setIsFinalSave(true);
        setDisabledFinalSave(true);
        setDisabledFactors(false);
        setDisabledInvoice(false);
      } else {
        setIsFinalSave(false);
        setDisabledFactors(true);
      }
    },
    [props.fetchDataLoading],
  );

  useEffect(() => {
    if (!props.isOpen) {
      socketInvoice.close();
    }
  }, [props.isOpen]);

  const renderSaveButtons = () => {
    if (permissionHelper.hasUserPermission(EDIT_INVOICE)) {
      const disabledTempSave =
        !editable || !newInvoiceItems || !newInvoiceItems.length;
      return (
        <>
          <button
            className='btn btn-primary mx-1'
            onClick={handleReceiptIssued}
            disabled={disabledInvoice || loading}
          >
            {locales('labels.receipt.issued')}
          </button>
          <button
            className='btn btn-info mx-1'
            onClick={handleTempSaveClick}
            disabled={disabledTempSave || loading}
          >
            {loader && !isFinalSave && <ButtonLoader />}
            {locales('labels.temp.save')}
          </button>
          <button
            className='btn btn-primary mx-1'
            onClick={handleFinalSaveClick}
            disabled={disabledFinalSave || loading}
          >
            {loader && isFinalSave && <ButtonLoader />}
            {locales('labels.invoice.billing')}
          </button>
        </>
      );
    }

    return null;
  };

  return (
    <>
      <Modal isOpen={props.isOpen} size='xl'>
        <ModalHeader>
          <span className='modal-title'>
            {locales('titles.invoice.modal', {
              invoiceNo: props.invoiceNo,
              cafeName: props.cafeName,
            })}
          </span>
          <span
            title={locales('labels.close.modal')}
            className='modal-close'
            onClick={close}
          >
            close
          </span>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading}>
            <div className='container'>
              <div className='row'>
                <div className='col-12 mb-2'>
                  <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                    {locales('titles.reserve.info')}
                  </div>
                  <div className='col-12 d-flex border rounded py-2 px-1 flex-wrap'>
                    <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-5 text-muted'>
                        {locales('labels.reserve.status')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {enumHelper.convertEnumValueToTitle(
                          enums.CAFE_RESERVATION.list,
                          props.reserveStatus,
                        )}
                      </div>
                    </div>
                    <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-5 text-muted'>
                        {locales('labels.invoice.status')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {enumHelper.convertEnumValueToTitle(
                          enums.INVOICE_STATUS.list,
                          props.invoiceStatus,
                        )}
                      </div>
                    </div>
                    <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-5 text-muted'>
                        {locales('labels.reserve.date')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {props.reserveDate}
                      </div>
                    </div>
                    <div className='col-6 d-flex align-items-center'>
                      <div className='col-5 text-muted'>
                        {locales('labels.reserve.hour')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {showReserveTimePeriod()}
                      </div>
                    </div>
                    <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-5 text-muted'>
                        {locales('fields.trackingNumber')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large direction-ltr'>
                        {props.trackingNumber}
                      </div>
                    </div>
                    <div className='col-6 d-flex align-items-center'>
                      <div className='col-5 text-muted'>
                        {locales('labels.reserve.individuals.count')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {props.individualsCount}
                      </div>
                    </div>
                    <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-5 text-muted'>
                        {locales('labels.tables.num')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {formatTablesNum(props.tablesNum)}
                      </div>
                    </div>
                    <div className='col-6 d-flex align-items-center'>
                      <div className='col-5 text-muted'>
                        {locales('labels.meals')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {enumHelper.convertEnumValueToTitle(
                          enums.MEAL_PORTIONS.list,
                          props.meal,
                        )}
                      </div>
                    </div>
                    <div className='col-12 d-flex justify-content-end align-items-center p-0'>
                      <div className='col-2 text-muted'>
                        {locales('labels.pre.order')} :{' '}
                      </div>
                      <div className='col-10 text-dark font-weight-bold font-large'>
                        {renderPreOrderedItems()}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-12 mb-3'>
                  <div className='col-12 p-0 py-1 font-weight-bold text-dark'>
                    {locales('titles.customer.info')}
                  </div>
                  <div className='col-12 d-flex border rounded py-2 px-1'>
                    <div className='col-6 d-flex align-items-center'>
                      <div className='col-5 text-muted'>
                        {locales('fields.name')} :{' '}
                      </div>
                      <div className='col-7 text-dark font-weight-bold font-large'>
                        {props.customerFullName}
                      </div>
                    </div>
                    {permissionHelper.hasUserPermission(
                      VIEW_USER_MOBILE_NUMBER,
                    ) && (
                        <div className='col-6 d-flex justify-content-end align-items-center p-0'>
                          <div className='col-5 text-muted'>
                            {locales('modal.user.mobile.number')} :{' '}
                          </div>
                          <div className='col-7 text-dark font-weight-bold font-large'>
                            {props.customerMobileNumber}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <hr />
              </div>
            </div>

            <OrderRegister onAddItem={addNewItem} />

            <div className='col-12'>
              <div className='panel panel-default'>
                <div className='panel-heading'>
                  <h3 className='panel-title'>
                    {locales('labels.order.items')}
                  </h3>
                </div>
                <div className='panel-body'>
                  <div className='table-responsive'>
                    <table className='table'>
                      <thead>
                        <tr>
                          <th className={styles.orderRowCol}>
                            {locales('labels.row')}
                          </th>
                          <th className={styles.orderItemCol} colSpan={3}>
                            {locales('labels.item')}
                          </th>
                          <th className={styles.orderQuantityCol}>
                            {locales('labels.qty')}
                          </th>
                          <th className={styles.orderUnitPriceCol}>
                            {locales('labels.unit.price')}
                          </th>
                          <th className={styles.orderItemCostCol}>
                            {locales('labels.item.cost')}
                          </th>
                          <th className={styles.orderActionsCol}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceItems.map((invoiceItem, ix) => (
                          <tr key={invoiceItem.clientKey}>
                            <td className={styles.orderRowCol}>{ix + 1}</td>
                            <td className={styles.orderItemCol} colSpan={3}>
                              {invoiceItem.title}
                            </td>
                            <td className={styles.orderQuantityCol} colSpan={1}>
                              {renderInvoiceItemQuantity(invoiceItem)}
                            </td>
                            <td className={styles.orderUnitPriceCol}>
                              {formatCurrencyValue(invoiceItem.price)}
                            </td>
                            <td className={styles.orderItemCostCol}>
                              {formatCurrencyValue(
                                invoiceItem.quantity * invoiceItem.price,
                              )}
                            </td>
                            <td className={styles.orderActionsCol}>
                              {editable && (
                                <span
                                  className={styles.removeInvoiceItemIcon}
                                  title={locales('labels.delete')}
                                  onClick={e =>
                                    removeItemFromInvoice(invoiceItem.clientKey)
                                  }
                                >
                                  <i className='fas fa-trash' />
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                        {/* {renderNewInvoiceRow()} */}
                        <tr>
                          <td
                            className={styles.thickLine}
                            colSpan='3'
                            rowSpan='8'
                          >
                            <InvoiceAdditionsList data={props.invoiceAdditions} />
                          </td>
                          <td className={styles.thickLine} colSpan='2'>
                            <strong>{locales('labels.sub.total.price')}</strong>
                          </td>
                          <td className={styles.thickLine} colSpan='2'>
                            {formatCurrencyValue(subTotalPrice, true)}
                          </td>
                          <td className={styles.thickLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>
                              {locales('labels.hourly.discount.amount')}
                            </strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(hourlyDiscountsAmount, true)}
                            &nbsp;(
                            {locales('labels.percent.value', {
                              percent: hourlyDiscountPercent
                                ? hourlyDiscountPercent
                                : 0,
                            })}
                            )
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>
                              {locales('labels.discount.code.amount')}
                            </strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(invoiceDiscountCodeAmount, true)}
                            &nbsp;(
                            {props.invoiceData.discountCodeType === 'PERCENT'
                              ? `${discountCodeAmount} درصد`
                              : formatCurrencyValue(discountCodeAmount, true)}
                            )
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{locales('entrance')}</strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(totalEntranceAmount, true)}
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{locales('labels.additions.amount')}</strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(invoiceAdditionsAmount, true)}
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{locales('labels.total.price')}</strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(totalPrice, true)}
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{locales('labels.pre.paid.amount')}</strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            {formatCurrencyValue(onlinePaidAmount, true)}
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>
                              {locales('labels.to.be.paid.to.cafe.price')}
                            </strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>
                              {formatCurrencyValue(toBePaidToCafePrice, true)}
                            </strong>
                          </td>
                          <td className={styles.noLine}></td>
                        </tr>
                        <tr>
                          <td
                            className={styles.thickLine}
                            colSpan='3'
                            rowSpan='2'
                          ></td>
                          <td className={styles.thickLine} colSpan='2'>
                            <strong>{locales('labels.rsee.stock.amount')}</strong>
                          </td>
                          <td className={styles.thickLine} colSpan='2'>
                            {formatCurrencyValue(rseeStockAmount, true)}&nbsp;(
                            {locales('labels.percent.value', {
                              percent: rseePercent,
                            })}
                            )
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{locales('labels.balance.amount')}</strong>
                          </td>
                          <td className={styles.noLine} colSpan='2'>
                            <strong>{formatBalanceAmount(balanceAmount)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <div style={{ display: 'none' }}>
            <InvoiceToPrint
              ref={invoiceToPrintRef}
              record={reservationFactorPrint}
              data={{
                currency: props.currency,
                reserveStartAt: props.reserveStartAt,
              }}
            />
          </div>
          <div style={{ display: 'none' }}>
            {reservationPrintData.length > 0 && (
              <DataToPrint
                ref={windowsPrintersRef}
                data={reservationPrintData[0]}
              />
            )}
          </div>

          {renderSaveButtons()}
          <button
            className='btn btn-light mx-1'
            onClick={close}
            disabled={loading}
          >
            {locales('labels.close.modal')}
          </button>
          <div className='w-100 d-flex mt-4'>
            <div className='border-box w-50 p-2 mx-2'>
              <div className='font-weight-bold text-dark mb-2'>
                {locales('titles.reserve.network.printers')}
              </div>
              <div className='d-inline'>
                {reservationTemporaryReceipt?.map(item => {
                  return (
                    <button
                      disabled={disabledInvoice || loading}
                      className='btn btn-primary mx-1 my-1'
                      onClick={() => handlePrinterTarget(item, 'network')}
                    >
                      {item.printerTitle}
                    </button>
                  );
                })}
                <button
                  className='btn btn-primary mx-4 my-1'
                  onClick={handleFactorIssued}
                  disabled={disabledFactors || loading}
                >
                  {locales('labels.invoice.billing.try.again')}
                </button>
              </div>

            </div>
            <div className='border-box w-50 p-2 mx-2'>
              <div className='font-weight-bold text-dark mb-2'>
                {locales('titles.reserve.windows.printers')}
              </div>
              <div className='d-inline'>
                {reservationTemporaryReceipt?.map(item => {
                  return (
                    <button
                      disabled={disabledInvoice || loading}
                      className='btn btn-success mx-1 my-1'
                      onClick={() => handlePrinterTarget(item, 'windows')}
                    >
                      {item.printerTitle}
                    </button>
                  );
                })}
                <button
                  className='btn btn-success mx-4 my-1'
                  onClick={onClickPrintFactor}
                  disabled={disabledFactors || loading}
                >
                  {locales('labels.invoice.billing.try.again')}
                </button>
              </div>

            </div>
          </div>
        </ModalFooter>
      </Modal>
      <ConfirmationModal
        isModalVisible={confirmationModalVisible}
        title={confirmationModalTitle}
        content={confirmationModalContent}
        onOkBtn={isTempSaveBtnClicked ? tempSave : finalSave}
        onCancelBtn={() => setConfirmationModalVisible(false)}
        loader={loader}
      />
      <Modal isOpen={isModalVisible}>
        <ModalBody>{` مجموع سفارشات، ${tempSaveData?.toBePaidToCafePriceDifference.toLocaleString()} تومان کمتر از پیش پرداخت می‌ باشد.`}</ModalBody>
        <ModalFooter>
          <Button color='success' onClick={()=> setIsModalVisible(false)}>
            بستن
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default InvoiceDetails;
